import type { UiKey } from './en';

export const ar: Record<UiKey, string> = {
  'lang.label': 'اللغة',

  'nav.residences': 'المساكن',
  'nav.mobility': 'التنقّل',
  'nav.retreats': 'الملاذات',
  'nav.slClub': 'SL Club',
  'nav.privateLine': 'Private Line',
  'nav.membership': 'العضوية',
  'nav.login': 'تسجيل الدخول',
  'nav.menu': 'القائمة',
  'nav.closeMenu': 'إغلاق القائمة',
  'nav.home': 'Superluxury — الصفحة الرئيسية',

  'menu.clientLine': 'خط العملاء',
  'menu.clientLineNote': 'يجيبك شريك في أي ساعة.',

  'announcement.text': 'نستقبل الاستشارات الخاصة الآن في مشاغلنا الجديدة في جنيف ودبي.',
  'announcement.link': 'اطلب لقاءً خاصًا',
  'announcement.close': 'إغلاق الإعلان',

  'hero.label': 'تعرّف إلى Superluxury',
  'hero.srTitle': 'Venturist — سلسلة فعاليات خاصة من Superluxury',
  'hero.tagline': 'سلسلة خاصة من Superluxury. بدعوة فقط.',
  'hero.discover': 'اكتشف Venturist',
  'hero.scroll': 'مرّر للاكتشاف',
  'hero.pause': 'إيقاف الفيلم مؤقتًا',
  'hero.play': 'تشغيل الفيلم',

  'footer.help': 'هل يمكننا مساعدتك؟',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.support': 'الدعم: الإنجليزية',
  'footer.house': 'الدار',
  'footer.locator': 'ابحث عن مشغل',
  'footer.locatorPlaceholder': 'الدولة/المنطقة، المدينة',
  'footer.findAtelier': 'ابحث عن مشغل',
  'footer.lettersTitle': 'اشترك في رسائل Superluxury',
  'footer.lettersBody': 'تلقَّ ملاحظات حصرية عن الخدمات الجديدة ودعوات شخصية وأخبارًا أخرى من عالم Superluxury.',
  'footer.lettersThanks': 'شكرًا لك. ستصلك الرسالة القادمة.',
  'footer.email': 'البريد الإلكتروني',
  'footer.signUp': 'اشترك',
  'footer.emailError': 'يرجى إدخال بريد إلكتروني صالح.',
  'footer.country': 'الدولة/المنطقة',
  'footer.services': 'خدمات Superluxury',
  'footer.discoverServices': 'اكتشف خدماتنا',
  'footer.seekIntro': 'اطلب تعريفًا',
  'footer.destinations': 'الوجهات',
  'footer.follow': 'تابعنا',
  'footer.rights': 'جميع الحقوق محفوظة.',
};
